import { cn } from "@/lib/utils";

export const SectionHeader = ({ eyebrow, title, subtitle, align = "left", className }) => {
  return (
    <div className={cn(align === "center" && "text-center mx-auto", "max-w-3xl", className)}>
      {eyebrow && (
        <p className="eyebrow mb-5 inline-flex items-center gap-3">
          <span className="divider-gold" /> {eyebrow}
        </p>
      )}
      {title && <h2 className="display-2">{title}</h2>}
      {subtitle && <p className="mt-6 text-base md:text-lg text-muted-foreground max-w-2xl leading-relaxed">{subtitle}</p>}
    </div>
  );
};
